const initState = {
    appName: "",
    branchName : "",
    storeName : "",
    cashierName: "",
    appId: null,
    branchId: null,
    storeId: null,
    cashierId: null,
    payWaitConfirm: false, 

    isValidating: false,
    isValidated: false,
    message: "",

    isSettingAccessible: true
};

const settingReducer = (state = initState, action) => {
    const data = action.data;
    switch(action.type){
        case "VALIDATE_SETTING":
            return {...state, isValidating: true,isValidated: false,message: ""};
        case "VALIDATE_SETTING_FAIL":
            return {...state, isValidating: false, isValidated: false, message: action.message};
        case "VALIDATE_SETTING_SUCCESS":
            return{
                ...state, 
                ...data,
                isValidating: false, isValidated: true, message: "", isSettingAccessible: false
            };
        case "LOGIN_SUCCESS":
            return{
                ...state,
                isSettingAccessible: true
            }
        default: 
            return state
    }
};

export default settingReducer;